import React from "react";
import ReactMarkdown from "react-markdown";
import { Gauge as GaugeIcon } from "lucide-react";
import styles from "./SitePerformanceViewer.module.css";
import uiStyles from "../../reportViewers/ReportUIPrimitives.module.css";

const parseSummaryLines = (markdown = "") => {
  const match = String(markdown || "").match(/Summary:\s*([\s\S]*)$/i);
  if (!match) return [];
  return String(match[1] || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => line.replace(/^[-\u2022]\s*/, ""))
    .filter((line) => !/^\*\*.*assessment.*\*\*$/i.test(line));
};

const SitePerformanceAssessmentViewerV2 = ({ markdown, title = "Core Web Vitals" }) => {
  if (!markdown) return null;
  const summaryLines = parseSummaryLines(markdown);

  return (
    <div className={styles.card}>
      <div className={styles.topBar}>
        <div className={styles.topBarLeft}>
          <div className={styles.brandIcon} aria-hidden="true">
            <GaugeIcon className={styles.brandIconGlyph} />
          </div>
          <div className={styles.topBarTitle}>{title}</div>
        </div>
        <div className={styles.topBarRight}>
          A snapshot of how your experience feels on real devices
        </div>
      </div>

      {summaryLines.length > 0 ? (
        <div className={styles.section}>
          <div className={styles.sectionTitle}>Summary</div>
          <div className={styles.sectionBody}>
            {summaryLines.map((line, idx) => (
              <div key={`summary-${idx}`} className={styles.sectionRow}>
                <span className={uiStyles.summaryCheck} aria-hidden="true" />
                <ReactMarkdown
                  components={{
                    p: ({ children }) => (
                      <p className={styles.sectionRowText}>{children}</p>
                    ),
                    strong: ({ children }) => (
                      <strong style={{ fontWeight: 700 }}>{children}</strong>
                    ),
                  }}
                >
                  {line}
                </ReactMarkdown>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.fallbackText}>{markdown}</div>
      )}
    </div>
  );
};

export default SitePerformanceAssessmentViewerV2;
